var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrash021(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 5.4974V4.83073C13.3333 3.89731 13.3333 3.4306 13.1517 3.07408C12.9919 2.76047 12.7369 2.50551 12.4233 2.34572C12.0668 2.16406 11.6001 2.16406 10.6667 2.16406H9.33333C8.39991 2.16406 7.9332 2.16406 7.57668 2.34572C7.26308 2.50551 7.00811 2.76047 6.84832 3.07408C6.66667 3.4306 6.66667 3.89731 6.66667 4.83073V5.4974M2.5 5.4974H17.5M15.8333 5.4974V14.8307C15.8333 16.2309 15.8333 16.9309 15.5608 17.4657C15.3212 17.9361 14.9387 18.3186 14.4683 18.5582C13.9335 18.8307 13.2335 18.8307 11.8333 18.8307H8.16667C6.76654 18.8307 6.06647 18.8307 5.53169 18.5582C5.06129 18.3186 4.67883 17.9361 4.43915 17.4657C4.16667 16.9309 4.16667 16.2309 4.16667 14.8307V5.4974",
    stroke: "#667085",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash021);
export default __webpack_public_path__ + "static/media/trash-02 (1).9635ba58b5fc9f36e10b9d99d067d559.svg";
export { ForwardRef as ReactComponent };